import {type MouseEventHandler} from 'react';
import { Container, MenuList } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Route from 'routes/Routes';
import type { StateSetter } from 'types';
import ArdoizBrand from 'components/brand/ArdoizBrand';
import { COLORS } from 'theme/MainTheme';
import clsx from 'clsx';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import ChangeModeButton from './ChangeModeButton';
import AppMenuItem from './AppMenuItem';
import {TOUR_STEPS} from '../../App/OnBoarding/OnBoardingTour';
import ChannelLinkSelect from '../../ChannelLink/ChannelLinkSelect';
import {Calendar, Document, Info, Mail} from 'components/icons';

const useStyles = makeStyles(() => ({
  icon: {
    padding: 10,
  },
  menu: {
    outline: 'none',
    padding: '20px 10px',

    '& .MuiMenuItem-root': {
      fontSize: 16,
      fontWeight: 'bold',
    },

    '&.tour': {
      '& .tour-step-communicate.selected': {
        border: `2px solid ${COLORS.VIOLET}`,
      },
      '& .tour-step-share.selected': {
        border: `2px solid ${COLORS.GREEN}`,
      },
      '& .tour-step-organize.selected': {
        border: `2px solid ${COLORS.LIGHT_RED}`,
      },
      '& .tour-step-help.selected': {
        border: `2px solid ${COLORS.YELLOW}`,
      },
    },
  },
}), {name: 'MainMenu'});

type MainMenuProps = {
  isTourOpen: boolean;
  goToHomeClick: MouseEventHandler;
  setIsOpened?: StateSetter<boolean>;
};

const MainMenu = ({ isTourOpen, goToHomeClick, setIsOpened }: MainMenuProps): JSX.Element => {
  const classes = useStyles();

  return <>
    <ArdoizBrand onClick={goToHomeClick} />

    {useSmallDesktopScreen() && (
      <Container>
        <ChannelLinkSelect />
      </Container>
    )}

    <MenuList className={clsx([classes.menu, isTourOpen && 'tour'])}>
      <AppMenuItem
        enableWithoutSelectedLink
        icon={<Mail htmlColor={COLORS.VIOLET} />}
        labelMessageId="category.communicate.label"
        step={TOUR_STEPS.COMMUNICATE}
        route={Route.COMMUNICATE}
      />

      <AppMenuItem
        icon={<Document htmlColor={COLORS.GREEN} />}
        labelMessageId="category.share.label"
        step={TOUR_STEPS.SHARE}
        route={Route.SHARE}
      />

      <AppMenuItem
        icon={<Calendar htmlColor={COLORS.RED} />}
        labelMessageId="category.organize.label"
        step={TOUR_STEPS.ORGANIZE}
        route={Route.ORGANIZE}
      />

      <AppMenuItem
        enableWithoutSelectedLink
        icon={<Info htmlColor={COLORS.YELLOW} />}
        labelMessageId="category.help.label"
        step={TOUR_STEPS.HELP}
        route={Route.HELP}
      />

      <ChangeModeButton setIsMenuOpened={setIsOpened} />
    </MenuList>
  </>;
};

export default MainMenu;